import React from "react";
import { DealInfoForm } from "./BaseDealInfoForm";
import type { DealInfoFormProps } from "./BaseDealInfoForm";
import Box from "@/ui/atoms/Box";

type EditDealInfoFormProps = Omit<DealInfoFormProps, "children">;

export const EditDealInfoForm: React.FC<EditDealInfoFormProps> = props => {
    return (
        <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
            <DealInfoForm {...props}>
                {({ onSubmit, isSubmitDisabled }) => (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            paddingBottom: "1rem",
                        }}
                    >
                        <Box sx={{ flex: 1 }} />
                        <Box
                            component="button"
                            type={"submit"}
                            onClick={event => {
                                void onSubmit(event);
                            }}
                            disabled={isSubmitDisabled}
                            sx={{
                                padding: "0.5rem 2rem",
                                border: "none",
                                borderRadius: "4px",
                                backgroundColor: isSubmitDisabled
                                    ? "var(--disabled-bg)"
                                    : "var(--primary-color)",
                                color: "var(--proda-white)",
                                cursor: isSubmitDisabled
                                    ? "not-allowed"
                                    : "pointer",
                            }}
                        >
                            Save Changes
                        </Box>
                    </Box>
                )}
            </DealInfoForm>
        </Box>
    );
};
